/* eslint-disable @typescript-eslint/no-use-before-define */
import {
    Action,
    ActionReducerMap,
    createFeatureSelector,
    createSelector,
    StoreModule,
} from '@ngrx/store';

import { Adventure } from '@polaris-customerweb/sharedcomponents.map';
import {
    AdventureAction,
    SetActiveAdventure,
    SetAdventures,
} from './adventure.actions';

export interface AdventureState {
    activeAdventure: Adventure | undefined;
    adventures: Adventure[];
}

const reducerMap: ActionReducerMap<AdventureState> = {
    activeAdventure: activeAdventureReducer,
    adventures: adventuresReducer,
};

export const selectAdventureState =
    createFeatureSelector<AdventureState>('adventure');
export const selectActiveAdventure = createSelector(
    selectAdventureState,
    (state) => state.activeAdventure
);
export const selectAdventure = createSelector(
    selectAdventureState,
    (state) => state.adventures
);

export const adventureStoreModule = StoreModule.forFeature(
    'adventure',
    reducerMap
);

function activeAdventureReducer(state: Adventure | undefined, action: Action) {
    switch (action.type) {
        case AdventureAction.setActiveAdventure:
            return (action as SetActiveAdventure).adventure;
        default:
            return state;
    }
}

function adventuresReducer(state = [], action: Action) {
    switch (action.type) {
        case AdventureAction.setAdventures:
            return (action as SetAdventures).adventures;
        default:
            return state;
    }
}
